<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "AggregatePayment",
        components: {CommonTable},
        data(){
            return {
                searchs:[{
                  name: 'agentId',
                  placeholder: '代理',
                  type: 'select',
                  selectUrl: '/agent/getAll',
                  selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '手机号',
                    type: 'input'
                  }, {
                    name: 'inOrderNo',
                    placeholder: '订单号',
                    type: 'input'
                  },
                  {
                    name: 'outOrderNo',
                    placeholder: '平台订单号',
                    type: 'input'
                  },
                  {
                    name: 'type',
                    placeholder: '小程序类型',
                    type: 'select',
                    selectValue:[
                      {
                        key: 1,
                        value: "抖音"
                      },
                      {
                        key: 2,
                        value: "微信"
                      }
                    ]
                  },
                  {
                    name: 'payChannel',
                    placeholder: '支付渠道',
                    type: 'select',
                    selectValue:[
                      {
                        key: 1,
                        value: "微信支付"
                      },
                      {
                        key: 2,
                        value: "支付宝支付"
                      },
                      {
                        key: 10,
                        value: "抖音支付"
                      }
                    ]
                  },{
                    name: 'status',
                    placeholder: '支付状态',
                    type: 'select',
                    selectValue:[
                      {
                        key: 1,
                        value: "待支付"
                      },
                      {
                        key: 2,
                        value: "待查询"
                      },
                      {
                        key: 3,
                        value: "成功"
                      },
                      {
                        key: 0,
                        value: "失败"
                      }
                    ]
                  }
                ],
                permission:{
                    add: 'aggregatePayment:add',
                    update: 'aggregatePayment:update',
                    delete: 'aggregatePayment:delete',
                    deleteBatch: 'aggregatePayment:deleteBatch'
                },
                url: {
                    get: '/aggregatePayment/listByCondition',
                    add: '/aggregatePayment/add',
                    update: '/aggregatePayment/update',
                    delete: '/aggregatePayment/delete/',
                    delete_batch: '/aggregatePayment/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                  field: 'agentId',
                  label: '代理',
                  selectUrl: '/agent/getAll',
                  selectData: [],
                  show: {
                    type: 'select',
                  },
                  detail: false,
                  width: '',
                },{
                  field: 'phone',
                  label: '用户',
                  show: true,
                  width: '',
                },{
                    field: 'appId',
                    label: 'appId',
                    show: false,
                    width: '',
                }, {
                    field: 'type',
                    label: '小程序类型',
                    show: {
                        type : 'select'
                    },
                    selectUrl: '',
                    selectData: [
                        {
                            id: 1,
                            name: '抖音'
                        },
                        {
                            id: 2,
                            name: '微信'
                        }
                    ],
                    width: '',
                }, {
                  field: 'amount',
                  label: '充值价格',
                  show: true,
                  width: '',
                }, {
                  field: 'totalAmount',
                  label: '支付价格',
                  show: false,
                  detail: true,
                  width: '',
                }, {
                  field: 'discountAmount',
                  label: '订单优惠金额',
                  show: false,
                  detail: true,
                  width: '',
                }, {
                  field: 'title',
                  label: '商品标题',
                  show: true,
                  width: '',
                }, {
                  field: 'validTime',
                  label: '订单过期时间',
                  show: false,
                  detail: true,
                  width: '',
                }, {
                  field: 'inOrderNo',
                  label: '订单号',
                  show: true,
                  width: '',
                }, {
                  field: 'outOrderNo',
                  label: '平台订单号',
                  show: true,
                  width: '',
                }, {
                  field: 'payChannel',
                  label: '支付渠道',
                  show: {
                    type : 'select'
                  },
                  selectUrl: '',
                  selectData: [
                    {
                      id: 1,
                      name: '微信支付'
                    },
                    {
                      id: 2,
                      name: '支付宝支付'
                    },
                    {
                      id: 10,
                      name: '抖音支付'
                    }
                  ],
                  width: '',
                }, {
                  field: 'channelPayId',
                  label: '渠道支付单号',
                  show: false,
                  detail: true,
                  width: '',
                }, {
                  field: 'channelNo',
                  label: '支付渠道侧单号',
                  show: false,
                  detail: true,
                  width: '',
                }, {
                  field: 'status',
                  label: '支付状态',
                  show: {
                    type : 'select'
                  },
                  selectUrl: '',
                  selectData: [
                    {
                      id: 1,
                      name: '待支付'
                    },
                    {
                      id: 2,
                      name: '待查询'
                    },
                    {
                      id: 3,
                      name: '成功'
                    },
                    {
                      id: 0,
                      name: '失败'
                    },
                    {
                      id: 4,
                      name: '支付超时'
                    },
                    {
                      id: 5,
                      name: '支付取消'
                    }
                  ],
                  width: '',
                }, {
                    field: 'merchantUid',
                    label: '卖家商户号',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'message',
                    label: '该笔交易取消原因',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                  field: 'eventTime',
                  label: '操作时间',
                  show: true,
                  width: '',
                }, {
                  field: 'userBillPayId',
                  label: '对应用户账单里的支付单号',
                  show: false,
                  detail: true,
                  width: '',
                },
                  {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                  }],
                operate: [],
                formFields: {
                  addTitle: '添加聚合支付',
                  updateTitle: '修改聚合支付',
                  model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
